import { useEffect, useState } from 'react';
import { useAssets } from '@facephi/inphinite-common';
import { FlexContainer, InputUpload } from '@facephi/ui-react';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ModalFaceInput, ModalIPStyles } from './Styles';
import { DESCRIPTION, ID, IMAGE_ID } from '../state/constants';
import { DataFaceModal, modalFaceSchema } from '../state/model';

type Props = {
  show?: boolean;
  onChangeShow(show: boolean): void;
  className?: string;
  onSave(face: DataFaceModal): void;
  data?: DataFaceModal;
};

export const ModalFace = ({
  show,
  onChangeShow,
  className,
  onSave,
  data,
}: Props) => {
  const { t } = useTranslation();
  const [face, setFace] = useState<File>();
  const [image, setImage] = useState<string | undefined>();

  const { uploadAsset, getAsset } = useAssets();

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(modalFaceSchema),
    mode: 'onChange',
  });

  const onSubmit: any = async (newFace: DataFaceModal) => {
    if (newFace && face) {
      const response = await uploadAsset(face);
      onSave({ ...newFace, media_id: response.id });
    } else if (newFace && !face) {
      onSave({ ...newFace });
    }
  };

  const setInnerData = () => {
    if (show && data) {
      setValue(IMAGE_ID, data.media_id);
      setValue(DESCRIPTION, data.description);
      setValue(ID, data.id);

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      getAsset(data.faceId).then((response: any) =>
        setImage(URL.createObjectURL(response))
      );
    }
  };

  useEffect(() => {
    reset({});
    setImage(undefined);
    setInnerData();
  }, [show]);

  const onSaveFile = (file: File) => {
    setFace(file);
    setValue(IMAGE_ID, file);
  };

  return (
    <ModalIPStyles
      className={className}
      show={show}
      header={{
        iconName: 'PlusCircle',
        title: t('Add a blocked face'),
      }}
      footer={{
        closeButtonLabel: t('close'),
        submitButtonLabel: t('Save'),
        onSubmitButton: handleSubmit(onSubmit),
      }}
      testId="modal-face"
      onChangeShow={onChangeShow}
      isForm
      hasPadding
    >
      <FlexContainer
        as="form"
        flexDirection="column"
        rowGap="4.8"
        alignItems="center"
      >
        <InputUpload
          testId="face-input-image"
          onChange={onSaveFile}
          messages={{
            errorMessage: t(errors.faceId?.message as string),
          }}
          value={image}
        />

        <Controller
          name="description"
          control={control}
          render={({ field }) => (
            <ModalFaceInput
              {...field}
              testId="face-input-desc"
              label={t('Description (optional)')}
              errorLabel={t(errors.description?.message as string)}
            />
          )}
        />
      </FlexContainer>
    </ModalIPStyles>
  );
};
